import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TruncateText from '../generic/TruncateText';
import classNames from 'classnames';

import { Card } from 'react/card/Card';
import RaisedTextBox from "react/views/generic/RaisedTextBox";
import CardTitle from 'react/card/CardTitle';
import ArticleLink from 'models/ArticleLink';
import TrackedLink from "react/views/generic/TrackedLink";
import ArticlesModalContainer from "react/containers/ArticlesModalContainer";
import SingleButtonFooter from "../../card/SingleButtonFooter";
import { OverviewFooter } from "../../card/OverviewFooter";
import Icon from "react/views/generic/Icon";

import './articles.less';

class Articles extends Component{
    constructor(props){
        super(props);
        this.state = {
			isModalOpen: false,
			displayFullList:false,
			numberOfItemsToRender: 3
        }
		this.onModalClose = this.onModalClose.bind(this);
		this.toggleDisplayFullList = this.toggleDisplayFullList.bind(this);
    }

    openArticleModal(article){
        this.setState({isModalOpen:true, modalContent: {name:article.title, url: article.contentUrl}});
    }

    onModalClose(){
        this.setState({isModalOpen: false});
	}

	toggleDisplayFullList(){
		this.setState((prevState) => ({
			displayFullList: !prevState.displayFullList
		}));
	}

    renderCount(text, articles){
        let countText = text;
        if(text && !text.endsWith(':')){
            countText += ':';
        }
        return (
			<RaisedTextBox>
				{countText + ` ${articles && articles.length}`}
			</RaisedTextBox>
        );
    }

    renderArticles(items, loggingId, eventType) {
		let listItems = items && items.map((article, index) => {
			return (
				<li className="clickable article-item" key={index} onClick={() => this.openArticleModal(article)}>
					<TrackedLink featureType={eventType} destId={article.uniqueId} srcId={loggingId}>
						<TruncateText line={2} text={article.title}/>
					</TrackedLink>
				</li>
			);
		});

		if(!this.state.displayFullList) {
			listItems = listItems.slice(0, this.state.numberOfItemsToRender);
		}

        return (
			<ol className={classNames('article-list', { 'scrollable-list': this.state.displayFullList })}>
				{ listItems }
			</ol>
		);
    }

    renderAbout(text){
        return (<p className="article-about">{text}</p>);
	}

    renderContent(articles, icon, iconColor, countText, aboutText, loggingId, eventType){
        return (
            <div className={classNames('article-card-content', {'article-card-content-full': this.state.displayFullList})}>
				{!this.state.displayFullList && <Icon icon={icon} color={iconColor} />}
				{!this.state.displayFullList && this.renderCount(countText, articles)}
                {!this.state.displayFullList && this.renderAbout(aboutText)}
				{this.renderArticles(articles, loggingId, eventType)}
            </div>
        );
	}

	renderFooter(articles){
		if(articles.length > this.state.numberOfItemsToRender){
			let text = this.state.displayFullList ? 'See less' : 'See more';
			return <SingleButtonFooter buttonText={text} onClick={() => this.toggleDisplayFullList()} />
		}
		else{
			return <OverviewFooter />
		}
	}

    render(){
        const {title, cardModel, icon, iconColor, countText, aboutText, loggingId, eventType} = this.props;
        return (
            <Card>
                <CardTitle title={title}/>
                {this.renderContent(cardModel, icon, iconColor, countText, aboutText, loggingId, eventType)}
                <ArticlesModalContainer isModalOpen={this.state.isModalOpen}
                    url={this.state.modalContent && this.state.modalContent.url}
                    name={this.state.modalContent && this.state.modalContent.name}
                    onModalClose={this.onModalClose}/>
				{this.renderFooter(cardModel)}
            </Card>
        );
    }
}

Articles.defaultProps = {
	iconColor: 'gray'
};

Articles.propTypes = {
    title: PropTypes.string.isRequired,
    loggingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    subheader: PropTypes.string,
    countText: PropTypes.string,
    aboutText: PropTypes.string,
	icon: PropTypes.func,
	iconColor: PropTypes.string,
	cardModel: PropTypes.arrayOf(PropTypes.instanceOf(ArticleLink)).isRequired,
	eventType: PropTypes.object
}

export default Articles;



// WEBPACK FOOTER //
// ./src/react/views/articles/Articles.jsx